import { useOptionCommercial } from "../../utils/options";
import { SingleValue } from "react-select";
import { useRange } from "../../context/rangeContext";
import { Choice } from "../../types/commercial";
import { useNavigate, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { getShortDatesByRange } from "../../utils/dateUtils";
import useBreakPoint from "../../utils/useBreakPoint";

const formatMobileLandscapeLabel = (label: string): string => {
  if (label && label.length > 15) {
    const words = label.split(" ");
    if (words.length > 0) {
      words[0] = `${words[0].slice(0, 3)}.`;
      return words.join(" ");
    }
  }
  return label;
};

export default function RangesSelector() {
  const { setKpiRange } = useRange();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const currentView = useBreakPoint();
    const isTablet =  currentView === "tablet";

  const handleSelect = (choice: SingleValue<Choice>) => {
    const newValue = choice?.value as string;
      if (newValue === location.pathname) {
        return;
      }
      const selectedOption = optionCommercial.find((opt) => opt.value === newValue);
      if (!!selectedOption) {
        setKpiRange("kpi_commercial", selectedOption.range);
      }
      navigate(newValue);
    };

  const optionCommercial = useOptionCommercial();

  const selectedOption = optionCommercial.find((opt) => opt.value === location.pathname);
  const selectedRange = selectedOption?.range;

  return (
    <div className="period-selector">
      <div className="label">
        <span className="label-mobile-landscape">
          {t("common.rangeShort_gen")}
        </span>
        <span className="label-default">
          {t(isTablet ? "common.rangeShort" : "common.range")}
        </span>
        <br className="tablet-break" />
        <span className="range-date range-date-default">
          {getShortDatesByRange(selectedRange, t, false)}
        </span>
        <span className="range-date range-date-mobile-landscape">
          {getShortDatesByRange(selectedRange, t, true)}
        </span>
      </div>

      <div className="button-group">
        {optionCommercial.map((option, index) => {
          const  isActive= location.pathname === option.value;
          const landscapeLabel = formatMobileLandscapeLabel(option.label);

          return (
            <button
              key={`${option.value}-${index}`}
              type="button"
              onClick={() => handleSelect(option)}
              className={`range-button ${isActive ? "active" : ""}`}
            >
              {landscapeLabel === option.label ? (
                option.label
              ) : (
                <>
                  <span className="button-text-default">{option.label}</span>
                  <span className="button-text-mobile-landscape">
                    {landscapeLabel}
                  </span>
                </>
              )}
            </button>
          );
        })}
      </div>

       <style>
        {`
          .period-selector {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 16px;
            width: calc(100% - 32px);
            margin: 12px auto 0;
            box-sizing: border-box;
            flex: 0 0 auto;
            height: fit-content;
            border-radius: var(--border-radius-m, 8px);
            border: 1px solid var(--Persistent-Border-Default, #EBEBEB);
            padding: 14px 18px;
            transform: rotate(0deg);
            background-color: #FFFFFF;
            box-shadow:
            0px 1px 2px -1px rgba(0, 0, 0, 0.1),
            0px 1px 3px 0px rgba(0, 0, 0, 0.1);
          }

          .label {
            font-size: var(--font-size-body-m, 16px);
            color: #000000;
            font-weight: 700;
          }

          .label-mobile-landscape {
            display: none;
          }

          .label-default {
            display: inline;
          }

          .button-text-mobile-landscape {
            display: none;
          }

          .button-text-default {
            display: inline;
          }

          .range-date {
            padding-left: 10px;
            font-weight: 400;
            font-style: normal;
            font-size: var(--font-size-body-s, 14px);
            line-height: var(--line-height-body-s, 20px);
            letter-spacing: var(--letter-spacing-normal, normal);
            color: #696969;
          }

          .range-date-mobile-landscape {
            display: none;
          }

          .range-date-default {
            display: inline;
          }

          .button-group {
            display: flex;
            gap: 8px;
            flex-wrap: wrap;
            margin-left: auto;
          }

          .range-button {
            border: solid 1px;;
            color: #4b5563;
            font-size: 13px;
            font-weight: 500;
            padding: 7px 14px;
            border-radius: 999px;
            cursor: pointer;
            transition: all 0.2s ease;
          }

          .range-button:hover {
            background: #e5e7eb;
          }

          .range-button.active {
            background: #2563eb;
            color: white;
          }

          @media (min-width: 768px) and (max-width: 1024px) {
            .button-group {
              width: 100%;
              max-height: calc(2 * 40px + 8px);
              overflow: hidden;
            }

            .button-group .range-button {
              flex: 1 1 calc(33.333% - 6px);
              height: 40px;
            }
          }

          .tablet-break {
            display: none;
          }

          @media (min-width: 768px) and (max-width: 1024px) {
            .tablet-break {
              display: block; /* ou inline */
            }
          }

          @media only screen and (max-width: 932px) and (orientation: landscape),
            only screen and (max-height: 560px) and (orientation: landscape) {
            .button-group {
              width: auto;
              max-height: none;
              overflow: visible;
            }

            .button-group .range-button {
              flex: initial;
              height: auto;
            }

            .tablet-break {
              display: none !important;
            }

            .label {
              white-space: nowrap;
            }

            .label-mobile-landscape {
              display: inline;
            }

            .label-default {
              display: none;
            }

            .range-date-default {
              display: none;
            }

            .range-date-mobile-landscape {
              display: inline;
            }

            .button-text-default {
              display: none;
            }

            .button-text-mobile-landscape {
              display: inline;
            }
          }
        `}
      </style>
    </div>
  );
}